// extracted by css-extract-rspack-plugin
export default {"heading":"TableHeading_heading__UiUEV"};